import {productDisplayPrice} from "@zaaaz/shared";
import {useI18n} from "./I18nProvider";
import {useSession} from "./SessionProvider";
import {useShopSite} from "./ShopSiteProvider";

type Props = {
  pretEuro: string;
  pretLei: string;
  className?: string;
  mainClass?: string;
  pricesHidden?: boolean;
};

export function ProductPrice({pretEuro, pretLei, className, mainClass, pricesHidden}: Props) {
  const {currency, t} = useI18n();
  const {user} = useSession();
  const {status, ready} = useShopSite();
  const hide = pricesHidden || (ready && !user?.authenticated && !status.guestPricesVisible);
  const cls = mainClass || className || "";
  if(hide) {
    return <span className={`${cls} cc-priceHidden`}>{t("Sign in to see price")}</span>;
  }
  const html = productDisplayPrice(pretEuro, pretLei, currency);
  if(!html) return null;
  return <span className={cls} dangerouslySetInnerHTML={{__html: html}} />;
}
